import React, { memo, useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { useSpring, animated } from '@react-spring/web'
import MyFreebirdOnboardingPanel from './MyFreebirdOnboardingPanel'

const MyFreebirdOnboarding = memo(
  ({
    data,
    pageText,
    user,
    step,
    discountCode,
    countriesNice,
    onboardingOpen,
    onUpdate,
    onClose,
    isCopied,
    iAminSubscriptionFormPanel,
    setIAminSubscriptionFormPanel,
    isCopiedInSubFormPanel,
    setIsCopiedInSubFormPanel,
    setShowPopup,
    setClickedFeeLink,
    actionRef

  }) => {
    const [showOnboarding, setShowOnboarding] = useState(false)

    useEffect(() => {
      setShowOnboarding(onboardingOpen)
    }, [onboardingOpen])


    

    const expandStyles = useSpring({
      config: { duration: showOnboarding ? 1000 : 600 },
      from: { maxHeight: '0' },
      to: {
        maxHeight: showOnboarding ? '8000px' : '0',
      },
    })

    if (!user) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ margin: '100px auto 100px', opacity: '0.3' }}
            role="status"
          ></div>
        </div>
      )
    }
    return (
      <animated.div
        style={{
          overflow: 'hidden',
          ...expandStyles,
        }}
      >
        <MyFreebirdOnboardingPanel
          actionRef={actionRef}
          data={data}
          discountCode={discountCode}
          pageText={pageText}
          user={user}
          step={step}
          countriesNice={countriesNice}
          onUpdate={onUpdate}
          onClose={onClose}
          isCopied={isCopied}
          iAminSubscriptionFormPanel={iAminSubscriptionFormPanel}
          setIAminSubscriptionFormPanel={setIAminSubscriptionFormPanel}
          isCopiedInSubFormPanel={isCopiedInSubFormPanel}
          setIsCopiedInSubFormPanel={setIsCopiedInSubFormPanel}
          setShowPopup={setShowPopup}
          setClickedFeeLink={setClickedFeeLink}
        />
      </animated.div>
    )
  }
)

export default withRouter(withAuth(MyFreebirdOnboarding))
